module.exports = __webpack_public_path__ + "img/game-avatar-2.0ee4db38.png";